export class uiPermissionsModel {
    uiPermissions: any = [];
}



// WEBPACK FOOTER //
// ./src/app/_models/permissions/uiPermissionModel.ts